import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapVoid } from '../ruutsApi/normalize'

// DELETE /v1/farmSubdivisions/:id answers `{ message }` with no payload. `deletePaddocks: true`
// also destroys the loteo's paddocks and their QUs/metric events, so the default must stay false.
export const deleteFarmSubdivision = async ({ id, deletePaddocks = false }) => {
  const response = await apiClient.delete(`${endpoints.farmSubdivisions}/${id}`, {
    params: { deletePaddocks },
  })
  return unwrapVoid(response)
}
